import React, { useState } from 'react';
import axios from 'axios';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import logo from './assets/Loyaltix.png'; // Replace with the correct path to your logo

function App() {
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false); 

  // State to manage form data for all fields
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    secteur_activite: '',
    other_secteur_activite: '', // Added for the 'Other' industry input
    role: '',
    other_role: '', // Added for the 'Other' role input
    num_employees: '',
    interest: '',
    features: [], // Array for multiple-choice features
    other_loyalty: '',
    budget: '',
    personalizationImportance: '',
    roi: '', 
  otherRoi: '', // Field for "Other" ROI option
  loyaltyProgram: '', // Single-choice loyalty program implementation
  otherLoyaltyProgram: '',
  satisfaction: '', 
  dissatisfaction: [], // Array for multiple-choice reasons for dissatisfaction
  other_dissatisfaction: '',
  ideal_features: '',
  implementation_time: '',
  });

  const [message, setMessage] = useState('');

  const handleCheckboxChange = (e) => {
    const {  value, checked } = e.target;
  
    setFormData(prevState => {
      const updatedDissatisfaction = checked
        ? [...prevState.dissatisfaction, value]
        : prevState.dissatisfaction.filter(item => item !== value);
  
      return {
        ...prevState,
        dissatisfaction: updatedDissatisfaction,
      };
    });
  };

  // Handle change for all form inputs
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
  
    if (type === 'checkbox') {
      setFormData(prevFormData => {
        const features = [...prevFormData.features];
        if (checked) {
          if (value === 'Other') {
            // Handle "Other" checkbox
            features.push(value);
          } else {
            features.push(value);
          }
        } else {
          const index = features.indexOf(value);
          if (index > -1) {
            features.splice(index, 1);
          }
        }
        return {
          ...prevFormData,
          features: features,
          other_loyalty: features.includes('Other') ? prevFormData.other_loyalty : '',
        };
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true); 

    // Basic email validation
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(formData.email)) {
    setMessage('Veuillez entrer une adresse email valide.');
    return; // Prevent form submission
  }

    console.log(formData);

    try {
      // Send form data to the Google Sheets API
      const response = await axios.post("/.netlify/functions/proxy", formData, {
        headers: {
          'Content-Type': 'text/plain;charset=utf-8',
        }
      });
  
      // Handle the response from the server
      if (response.data.status === 'success') {
        setMessage('Votre réponse a été enregistrée. Merci !');
        
        // Reset form after successful submission
        setFormData({
          name: '',
          email: '',
          secteur_activite: '',
          other_secteur_activite: '',
          role: '',
          other_role: '',
          num_employees: '',
          interest: '',
          features: [],
          other_loyalty: '',
          budget: '',
          personalizationImportance: '',
          roi: '',
          otherRoi: '',
          loyaltyProgram: '',
          otherLoyaltyProgram: '',
          satisfaction: '',
          dissatisfaction: [],
          other_dissatisfaction: '',
          ideal_features: '',
          implementation_time: ''
        });
      } else {
        console.log(response);
        
        setMessage(`Une erreur s'est produite lors de l'envoi de votre réponse. ${response.data.message}` , response.message);
      }
    } catch (error) {
      setMessage("Une erreur s'est produite. Veuillez réessayer.");
      console.error("Erreur lors de l'envoi du formulaire :", error);
    } finally {
      setLoading(false); 
    }
  };

  // Handle the button to reveal the survey form
  const handleEnterSurvey = () => {
    setShowForm(true);
  };

  return (
    <div style={{ minHeight: "100%" }} className="App">
      {/* Logo and introduction */}
      <div className="container text-center mt-5">
        <img src={logo} alt="Loyaltix Logo" className="mb-4" width="200" />
        <h1>Loyaltix Sondage</h1>
        <br/>
        {!showForm ? (
          <>
            {/* Introduction Text */}
            <div className="card mb-4">
  <div className="card-body">
  <p className="lead mb-0" style={{ textAlign: 'left', fontWeight: 'bold' }}>
      Nous préparons le lancement de Loyaltix, une application B2B de fidélisation adaptée aux secteurs de la distribution comme les superettes, pharmacies, et cosmétique...etc.<br />
      Utilisant un système de points, cette solution offre des réductions, cadeaux, et services exclusifs.<br />
      Votre avis via ce sondage nous aidera à affiner notre offre pour mieux répondre à vos besoins stratégiques.
    </p>
  </div>
  
</div>
<div className=" text-center">
    <button className="btn btn-primary" onClick={handleEnterSurvey}>
      Commancer
    </button>
  </div>
          </>
        ) : (
          <>
            {/* Survey Form */}
            <div className="container p-4 shadow rounded">
              <form id="surveyForm" onSubmit={handleSubmit}>

              <div className="container d-md-flex w-100 justify-content-around p-4 shadow rounded mb-5 gap-5">
  <div className="mb-3 w-100 w-md-25">
    <label htmlFor="name" className="form-label custom-label">
      Nom
    </label>
    <input
      type="text"
      className="form-control"
      id="name"
      name="name"
      value={formData.name}
      onChange={handleChange}
      required
    />
  </div>
  <div className="mb-3 w-100 w-md-25">
    <label htmlFor="email" className="form-label custom-label">
      Email
    </label>
    <input
      type="email"
      className="form-control"
      id="email"
      name="email"
      value={formData.email}
      onChange={handleChange}
      required
    />
    {formData.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email) && (
      <div className="text-danger mt-2">
        Veuillez entrer une adresse email valide.
      </div>
    )}
  </div>
</div>
              



                {/* Controlled input for Industry */}
                <div className="mb-3">
                  <label  style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="secteur_activite" className="form-label">
                    1. Quel est le secteur d'activité principal de votre entreprise ?
                  </label>
                  <select
                    className="form-select"
                    id="secteur_activite"
                    name="secteur_activite"
                    value={formData.secteur_activite}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Sélectionnez votre secteur d'activité</option>
                    <option value="Distribution">Distribution</option>
                    <option value="Agroalimentaire">Agroalimentaire</option>
                    <option value="Technologie et électroménager">Technologie et électroménager</option>
                    <option value="Pharmaceutique">Pharmaceutique</option>
                    <option value="Hygiène et beauté">Hygiène et beauté</option>
                    <option value="Other">Autre</option>
                  </select>
                </div>

                {formData.secteur_activite === 'Other' && (
                  <div className="mb-3">
                    <label  htmlFor="other_secteur_activite" className="form-label">
                      Veuillez préciser votre secteur d'activité
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="other_secteur_activite"
                      name="other_secteur_activite"
                      value={formData.other_secteur_activite}
                      onChange={handleChange}
                      placeholder="Veuillez spécifier"
                    />
                  </div>
                )}

                {/* Controlled input for Role */}
                <div className="mb-3">
                  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="role" className="form-label">
                    2. Quelle est votre fonction au sein de l'entreprise ?
                  </label>
                  <select
                    className="form-select"
                    id="role"
                    name="role"
                    value={formData.role}
                    onChange={handleChange}
                    required
                  >
                    <option value="" disabled>Sélectionnez votre rôle</option>
                    <option value="PDG">PDG</option>
                    <option value="Directeur Marketing">Directeur Marketing</option>
                    <option value="Directeur Commercial">Directeur Commercial</option>
                    <option value="Other">Autre</option>
                  </select>
                </div>

                {formData.role === 'Other' && (
                  <div className="mb-3">
                    <label htmlFor="other_role" className="form-label">
                      Veuillez préciser votre rôle
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="other_role"
                      name="other_role"
                      value={formData.other_role}
                      onChange={handleChange}
                      placeholder="Veuillez spécifier"
                    />
                  </div>
                )}


                {/* Controlled input for Number of Employees */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="num_employees" className="form-label">
    3. Combien d'employés compte votre entreprise ?
  </label>
  <select
    className="form-select"
    id="num_employees"
    name="num_employees"
    value={formData.num_employees}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez le nombre d'employés</option>
    <option value="10-50">10-50</option>
    <option value="51-200">51-200</option>
    <option value="201-500">201-500</option>
    <option value="501-1000">501-1000</option>
    <option value="Plus de 1000">Plus de 1000</option>
  </select>
</div>



{/* Controlled input for Interest in Loyalty Program */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="interest" className="form-label">
    4. Êtes-vous intéressé par l'introduction d'un programme de fidélisation pour votre entreprise ?
  </label>
  <select
    className="form-select"
    id="interest"
    name="interest"
    value={formData.interest}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez une option</option>
    <option value="Oui, absolument">Oui, absolument</option>
    <option value="Peut-être, j'aimerais en savoir plus">Peut-être, j'aimerais en savoir plus</option>
    <option value="Non, pas intéressé">Non, pas intéressé</option>
  </select>
</div>




                {/* Controlled input for Loyalty Program Features */}
<div style={{textAlign: 'left' , display : "block"}} className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} className="form-label">
    5. Quelles fonctionnalités d'un programme de fidélisation trouveriez-vous les plus utiles ?
  </label>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="accumulation_points"
      name="features"
      value="Accumulation de points échangeables"
      checked={formData.features.includes('Accumulation de points échangeables')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="accumulation_points">
      Accumulation de points échangeables
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="personalized_rewards"
      name="features"
      value="Récompenses personnalisées"
      checked={formData.features.includes('Récompenses personnalisées')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="personalized_rewards">
      Récompenses personnalisées
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="exclusive_offers"
      name="features"
      value="Offres exclusives aux membres"
      checked={formData.features.includes('Offres exclusives aux membres')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="exclusive_offers">
      Offres exclusives aux membres
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="freebies"
      name="features"
      value="Gratuité"
      checked={formData.features.includes('Gratuité')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="freebies">
      Gratuité
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="invoice_discount"
      name="features"
      value="Remise sur facture"
      checked={formData.features.includes('Remise sur facture')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="invoice_discount">
      Remise sur facture
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="other_loyalty"
      name="features"
      value="Other"
      checked={formData.features.includes('Other')}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="other_loyalty">
      Autre
    </label>
    {formData.features.includes('Other') && (
      <input
        type="text"
        className="form-control mt-2"
        id="other_loyalty"
        name="other_loyalty"
        value={formData.other_loyalty}
        onChange={handleChange}
        placeholder="Veuillez spécifier"
      />
    )}
  </div>
</div>


{/* Controlled input for Monthly Budget */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="budget" className="form-label">
    6. Quel budget mensuel prévoyez-vous d'allouer à un programme complet incluant la gestion de votre base de données (BDD), l'accompagnement technique, le service après-vente, la création de contenu et de challenges, le support pour vos équipes sur le terrain et les merchandisers, le support client, ainsi que le traitement des données ?
  </label>
  <select
    className="form-select"
    id="budget"
    name="budget"
    value={formData.budget}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez votre budget</option>
    <option value="Moins de 500 000 DA">Moins de 500 000 DA</option>
    <option value="500 000 à 1 000 000 DA">500 000 à 1 000 000 DA</option>
    <option value="Plus de 1 000 000 DA">Plus de 1 000 000 DA</option>
    <option value="Incertain pour le moment">Incertain pour le moment</option>
  </select>
</div>



{/* Controlled input for Reward Personalization Importance */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="personalizationImportance" className="form-label">
    7. À quel point la personnalisation des récompenses est-elle importante pour vous ?
  </label>
  <select
    className="form-select"
    id="personalizationImportance"
    name="personalizationImportance"
    value={formData.personalizationImportance}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez l'importance</option>
    <option value="Très importante">Très importante</option>
    <option value="Moyennement importante">Moyennement importante</option>
    <option value="Peu importante">Peu importante</option>
  </select>
</div>


{/* Controlled input for ROI Expectations */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="roi" className="form-label">
    8. Quel retour sur investissement attendez-vous d'un programme de fidélisation ?
  </label>
  <select
    className="form-select"
    id="roi"
    name="roi"
    value={formData.roi}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez un retour sur investissement</option>
    <option value="Augmentation des ventes">Augmentation des ventes</option>
    <option value="Meilleure rétention de clients">Meilleure rétention de clients</option>
    <option value="Acquisition de nouveaux clients">Acquisition de nouveaux clients</option>
    <option value="Merchandising">Merchandising</option>
    <option value="Other">Autre</option>
  </select>
</div>

{/* Show additional input if "Other" is selected */}
{formData.roi === 'Other' && (
  <div className="mb-3 mt-2">
    <label htmlFor="otherRoi" className="form-label">
      Veuillez préciser
    </label>
    <input
      type="text"
      className="form-control"
      id="otherRoi"
      name="otherRoi"
      value={formData.otherRoi}
      onChange={handleChange}
      placeholder="Veuillez spécifier"
    />
  </div>
)}

{/* Controlled input for Loyalty Program Implementation */}
<div style={{ textAlign: 'left', display: 'block' }} className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} className="form-label">
    9. Avez-vous déjà implémenté un programme de fidélisation ?
  </label>
  <div className="form-check">
    <input
      type="radio"
      className="form-check-input"
      id="implementedYes"
      name="loyaltyProgram"
      value="Oui"
      checked={formData.loyaltyProgram === 'Oui'}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="implementedYes">
      Oui (veuillez décrire dans Autres)
    </label>
  </div>
  <div className="form-check">
    <input
      type="radio"
      className="form-check-input"
      id="implementedNo"
      name="loyaltyProgram"
      value="Non"
      checked={formData.loyaltyProgram === 'Non'}
      onChange={handleChange}
    />
    <label className="form-check-label" htmlFor="implementedNo">
      Non
    </label>
  </div>

  {/* Show additional input if "Oui" is selected */}
  {formData.loyaltyProgram === 'Oui' && (
    <div className="mb-3 mt-2">
      <label htmlFor="otherLoyaltyProgram" className="form-label">
        Veuillez décrire
      </label>
      <textarea
        rows="4"
        className="form-control"
        id="otherLoyaltyProgram"
        name="otherLoyaltyProgram"
        value={formData.otherLoyaltyProgram}
        onChange={handleChange}
        placeholder="Décrivez votre programme de fidélisation"
        required
      />
    </div>
  )}
</div>

                  {/* Controlled input for Satisfaction with Loyalty Program */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="satisfaction" className="form-label">
    10. Êtes-vous satisfait de votre programme de fidélisation actuel ?
  </label>
  <select
    className="form-select"
    id="satisfaction"
    name="satisfaction"
    value={formData.satisfaction}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez une option</option>
    <option value="Oui, et j'en suis satisfait.">Oui, et j'en suis satisfait.</option>
    <option value="Oui, mais je ne suis pas satisfait.">Oui, mais je ne suis pas satisfait.</option>
    <option value="Non, je n'utilise pas de système de fidélisation">Non, je n'utilise pas de système de fidélisation</option>
  </select>
</div>

{/* Controlled input for Reasons for Dissatisfaction */}
<div style={{textAlign: 'left' , display : "block"}}  className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} className="form-label">
    11. Pourquoi n'êtes-vous pas satisfait de votre système actuel de fidélisation ?
  </label>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionNeeds"
      name="dissatisfaction"
      value="Il ne répond pas complètement aux besoins de mon entreprise."
      checked={formData.dissatisfaction.includes("Il ne répond pas complètement aux besoins de mon entreprise.")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionNeeds">
      Il ne répond pas complètement aux besoins de mon entreprise.
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionComplex"
      name="dissatisfaction"
      value="Il est trop complexe à utiliser"
      checked={formData.dissatisfaction.includes("Il est trop complexe à utiliser")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionComplex">
      Il est trop complexe à utiliser
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionCost"
      name="dissatisfaction"
      value="Il est trop coûteux"
      checked={formData.dissatisfaction.includes("Il est trop coûteux")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionCost">
      Il est trop coûteux
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionData"
      name="dissatisfaction"
      value="Il ne fournit pas suffisamment de données ou d'analyses utiles"
      checked={formData.dissatisfaction.includes("Il ne fournit pas suffisamment de données ou d'analyses utiles")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionData">
      Il ne fournit pas suffisamment de données ou d'analyses utiles
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionEngagement"
      name="dissatisfaction"
      value="Les clients ne semblent pas engagés par le système"
      checked={formData.dissatisfaction.includes("Les clients ne semblent pas engagés par le système")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionEngagement">
      Les clients ne semblent pas engagés par le système
    </label>
  </div>
  <div className="form-check">
    <input
      type="checkbox"
      className="form-check-input"
      id="dissatisfactionOther"
      name="dissatisfaction"
      value="Other"
      checked={formData.dissatisfaction.includes("Other")}
      onChange={handleCheckboxChange}
    />
    <label className="form-check-label" htmlFor="dissatisfactionOther">
      Autre
    </label>
    {formData.dissatisfaction.includes("Other") && (
      <input
        type="text"
        className="form-control mt-2"
        name="other_dissatisfaction"
        value={formData.other_dissatisfaction}
        onChange={handleChange}
        placeholder="Veuillez spécifier"
      />
    )}
  </div>
</div>

{/* Controlled input for Desired Features in Ideal Loyalty Program */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="idealFeatures" className="form-label">
    12. Quelles caractéristiques ou fonctions souhaiteriez-vous voir dans un programme de fidélisation idéal ?
  </label>
  <textarea
    className="form-control"
    id="idealFeatures"
    name="ideal_features"
    value={formData.ideal_features}
    onChange={handleChange}
    placeholder="Décrivez les caractéristiques ou fonctions souhaitées"
    rows="4"
  />
</div>


{/* Controlled input for Implementation Time */}
<div className="mb-3">
  <label style={{ textAlign: 'left', fontWeight: 'bold', display: 'block' }} htmlFor="implementationTime" className="form-label">
    13. Combien de temps pensez-vous nécessiter pour mettre en place ce programme de fidélisation clé en main ?
  </label>
  <select
    className="form-select"
    id="implementationTime"
    name="implementation_time"
    value={formData.implementation_time}
    onChange={handleChange}
    required
  >
    <option value="" disabled>Sélectionnez une option</option>
    <option value="1 à 3 mois">1 à 3 mois</option>
    <option value="3 à 6 mois">3 à 6 mois</option>
    <option value="Plus de 6 mois">Plus de 6 mois</option>
    <option value="Je ne suis pas sûr">Je ne suis pas sûr</option>
  </select>
</div>
                {/* Other form fields */}
                {/* Add additional fields for 'num_employees', 'interest', etc. */}

                {/* Submit button */}
                <button type="submit" className="btn btn-success" disabled={loading}>
        {loading ? "Envoi en cours..." : "Envoyer"}
      </button>
              </form>

              {/* Message display */}
              {message && <div className="mt-3 alert alert-info">{message}</div>}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default App;
